import { DBAdapter, LockContext } from '@powersync/common';
import { Mutex } from '@powersync/shared-internals';
const MOCK_QUERY_RESPONSE = {
    rowsAffected: 0,
    columnNames: [],
    rawRows: []
};
/**
 * Implements a Mock DB adapter for use in Server Side Rendering (SSR).
 * This adapter will return empty results for queries, which will allow
 * server rendered views to initially generate scaffolding components
 */
export class SSRDBAdapter extends DBAdapter {
    name;
    readMutex;
    writeMutex;
    constructor() {
        super();
        this.name = 'SSR DB';
        this.readMutex = new Mutex();
        this.writeMutex = new Mutex();
    }
    close() { }
    async readLock(fn, options) {
        return fn(new StubLockContext());
    }
    async writeLock(fn, options) {
        return fn(new StubLockContext());
    }
    async refreshSchema() { }
}
class StubLockContext extends LockContext {
    async executeRaw() {
        return MOCK_QUERY_RESPONSE;
    }
}
//# sourceMappingURL=SSRDBAdapter.js.map